var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "159px",
    height: "141px",
    viewBox: "0 0 159 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page-(Desktop)",
    transform: "translate(-642.000000, -477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(642.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.690812,15.6010714 L151.281119,15.6010714 C154.263456,15.6010714 156.681119,18.0187338 156.681119,21.0010714 C156.681119,21.5740198 156.589936,22.1433176 156.410992,22.6876052 L127.561677,110.437605 C126.833186,112.653432 124.76431,114.151071 122.431804,114.151071 L16.9908117,114.151071 L16.9908117,114.151071 L52.0908117,15.6010714 L91.2408117,15.6010714",
    id: "Path",
    stroke: "#8D919B",
    fill: "#8D919B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.690812,15.6010714 L130.516195,15.6010714 C134.244118,15.6010714 137.266195,18.6231493 137.266195,22.3510714 C137.266195,23.0672569 137.152217,23.7788792 136.928538,24.4592387 L108.661677,110.437605 C107.933186,112.653432 105.86431,114.151071 103.531804,114.151071 L8.25050468,114.151071 C5.26816703,114.151071 2.85050468,111.733409 2.85050468,108.751071 C2.85050468,108.178123 2.94168715,107.608825 3.12063102,107.064538 L31.9699461,19.3145376 C32.698437,17.0987112 34.7673135,15.6010714 37.0998197,15.6010714 L42.6408117,15.6010714 L42.6408117,15.6010714 M50.7408117,15.6010714 L91.2408117,15.6010714",
    id: "Shape",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5623144,43.9510714 L32.7607062,19.0572255 C33.3076858,17.3963602 34.8588473,16.2740939 36.6074639,16.2740939 L131.434912,16.2740939 C134.417249,16.2740939 136.834912,18.6917562 136.834912,21.6740939 C136.834912,22.2372266 136.746826,22.7968938 136.57385,23.332802 L129.918839,43.9510714 L129.918839,43.9510714 L24.5623144,43.9510714 Z",
    id: "Path-2",
    fill: "#DBF3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.802701,11.6473904 C126.01206,9.36443997 124.725252,7.3131947 123.071268,5.62264549 C120.130292,2.61665259 116.028417,0.751071401 111.490812,0.751071401 C102.543799,0.751071401 95.2908117,8.00405845 95.2908117,16.9510714 C95.2908117,25.8980843 102.543799,33.1510714 111.490812,33.1510714 C114.925682,33.1510714 118.110872,32.082062 120.731831,30.2585939",
    id: "Path",
    stroke: "#8D919B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2027012,11.6473904 C77.41206,9.36443997 76.1252519,7.3131947 74.4712678,5.62264549 C71.5302919,2.61665259 67.4284167,0.751071401 62.8908117,0.751071401 C53.9437987,0.751071401 46.6908117,8.00405845 46.6908117,16.9510714 C46.6908117,25.8980843 53.9437987,33.1510714 62.8908117,33.1510714 C66.3256822,33.1510714 69.5108723,32.082062 72.1318312,30.2585939",
    id: "Path",
    stroke: "#8D919B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 23.7408117,
    y: 43.9510714,
    width: 109.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 29,
    y: 131,
    width: 56,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 45,
    y: 140,
    width: 24,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "#8D919B",
    fill: "#28CAF4",
    strokeLinecap: "round",
    points: "45 59 105 59 90 102 30 102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,89 C62.8954305,89 62,88.1045695 62,87 C62,85.8954305 62.8954305,85 64,85 L70,85 L70,67 C70,65.8954305 70.8954305,65 72,65 C73.1045695,65 74,65.8954305 74,67 L74,87 L74,87 C74,88.0543618 73.1841222,88.9181651 72.1492623,88.9945143 L72,89 L72,89 L64,89 Z",
    id: "Combined-Shape",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round",
    transform: "translate(68.000000, 77.000000) rotate(45.000000) translate(-68.000000, -77.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.790812, 14.251071)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.587e3696.svg";
export { ForwardRef as ReactComponent };